module.exports = __webpack_public_path__ + "media/images/icons/firefox_logo-6cf8837c0989a82ad7f8a87e1da0577c.svg";